import script from "./preparation-status-compact.vue?vue&type=script&lang=ts&setup=true"
export * from "./preparation-status-compact.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__